import type { ReactElement } from 'react';
import { CLOCK_SKEW_WARN_MS, DEVICE_OFFLINE_THRESHOLD_SEC, HEARTBEAT_SEC } from '@pbtv/shared';
import { PageHeader } from '../components/PageHeader.js';
import { EmptyState } from '../components/EmptyState.js';

export function DevicesPage(): ReactElement {
  return (
    <>
      <PageHeader
        title="Devices"
        description="What each Fire TV stick is doing right now, and the commands that fix it without a drive to the store."
      />
      <EmptyState
        milestone="M4"
        title="Monitoring arrives with the heartbeat"
        description={`Every device checks in about every ${HEARTBEAT_SEC} seconds and is treated as offline after ${Math.round(DEVICE_OFFLINE_THRESHOLD_SEC / 60)} minutes of silence. Commands ride the same heartbeat, so a screen answers within one cycle rather than needing a connection held open.`}
        points={[
          'Online state read against store hours, so a TV that is off overnight is not raised as a fault',
          'Now playing, app version, free storage, IP and model',
          `Clock skew, flagged past ${Math.round(CLOCK_SKEW_WARN_MS / 1000)} seconds, because a wrong clock silently breaks dayparting`,
          'The one-time ADB grants, self-checked by the app — without them a stick stops auto-starting after the next reboot',
          'Remote commands: reload, restart the app, clear the cache, apply a staged update',
          'Un-pairing, which deletes the device token and returns the TV to its pairing screen',
        ]}
      />
    </>
  );
}
